/**
 * Punto de entrada del navegador. Lo unico que tiene efectos al cargarse.
 *
 * Todo lo demas --`formato.ts`, `peticiones.ts`, `api.ts`, las vistas-- se
 * puede importar desde una prueba sin que nada se monte, igual que en
 * `services/api`, donde el `listen` vive en `main.ts` y no en `crearServidor`.
 */

import { arrancar } from './app';
import './estilo.css';

const raiz = document.getElementById('app');

if (raiz === null) {
  throw new Error('No existe el elemento #app: revisa index.html.');
}

arrancar(raiz);
